<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="1400">
			<v-card>
				<v-card-title class="h6 pr-2">
					<span>Print Preview</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" @click="hideDialog">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="4" class="px-5" app>
							<div class="pb-3">
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Header</div>
									<v-checkbox v-model="header" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Detail Surat</div>
									<v-checkbox v-model="detailLetter" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Detail Status</div>
									<v-checkbox v-model="detailStatus" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Detail Warehouse</div>
									<v-checkbox v-model="detailWarehouse" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Produk</div>
									<v-checkbox v-model="productSummary" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Catatan</div>
									<v-checkbox v-model="note" class="mt-0" hide-details></v-checkbox>
								</div>
							</div>
							<v-btn text large depressed class="primary col-12 mt-5" @click="printDiv(detailTDO.tdo_code)">
								<v-icon>mdi-printer</v-icon>
								<div class="pl-2">Print</div>
							</v-btn>
						</v-col>
						<v-col cols="8" class="deep-purple lighten-5 rounded-lg frame-pdf">
							<v-card elevation="10" tile class="pa-5">
								<div class="white in-print" id="box-print">
									<div class="pb-3" v-if="header">
										<div class="d-flex flex-wrap border-bottom border-2px">
											<v-col cols="7" class="pt-0 px-0">
												<div class="d-flex justify-start">
													<div class="d-flex align-center">
														<img width="110" height="auto" src="/assets/icon/milagros-icon.png">
													</div>
													<div class="ml-4">
														<div class="font-size-14 font-weight-bold"><!-- {{ letterHeader.letter_title }} --></div>
														<div class="pt-1 font-size-9">
															<div>{{ letterHeader.letter_address }}</div>
															<div>Phone: {{ letterHeader.letter_phone }}</div>
															<div>email: {{ letterHeader.letter_email }}</div>
															<div>web: {{ letterHeader.letter_web }}</div>
														</div>
													</div>
												</div>
											</v-col>
											<v-col cols="5" class="pt-0 px-0 my-auto">
												<div class="d-flex justify-end">
													<div class="font-size-14 font-weight-bold">
														<div class="border border-2px px-3 py-1 text-uppercase">Transfer Stok</div>
													</div>
												</div>
											</v-col>
										</div>
									</div>
									<div class="pb-3" v-if="detailLetter">
										<div class="border-topbot-dotted py-3 mt-3">
											<v-row>
												<v-col cols="12" class="pb-0">
													<v-row>
														<v-col cols="3" class="py-0">
															<v-row class="pl-3 justify-space-between">
																<v-col cols="11" class="pa-0"><div class="text-body-2 font-weight-bold">Nomor</div></v-col>
																<v-col cols="1" class="pa-0"><div>:</div></v-col>
															</v-row>
														</v-col>
														<v-col cols="9" class="pl-0 py-0">
															<span class="text-body-2 font-weight-bold">{{ detailTDO.tdo_code }}</span>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
											<v-row>
												<v-col cols="12">
													<v-row>
														<v-col cols="3" class="py-0">
															<v-row class="pl-3 justify-space-between">
																<v-col cols="11" class="pa-0"><div class="text-body-2">Atas Nama</div></v-col>
																<v-col cols="1" class="pa-0"><div>:</div></v-col>
															</v-row>
														</v-col>
														<v-col cols="9" class="pl-0 py-0">
															<span class="text-body-2">{{ detailTDO.tdo_status_created_user_name }}</span>
														</v-col>
														<v-col cols="3" class="py-0">
															<v-row class="pl-3 justify-space-between">
																<v-col cols="11" class="pa-0"><div class="text-body-2">Tanggal</div></v-col>
																<v-col cols="1" class="pa-0"><div>:</div></v-col>
															</v-row>
														</v-col>
														<v-col cols="9" class="pl-0 py-0">
															<span class="text-body-2">{{ detailTDO.tdo_status_created_datetime | tanggal }}</span>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
										</div>
									</div>
									<div class="pb-3" v-if="detailStatus">
										<div class="pb-3 border-bot-dotted">
											<v-row>
												<v-col cols="6">
													<div>
														<v-row>
															<v-col cols="6" class="py-0">
																<v-row class="pl-3 justify-space-between">
																	<v-col cols="11" class="pa-0"><div class="text-body-2">Dibuat Oleh</div></v-col>
																	<v-col cols="1" class="pa-0"><div>:</div></v-col>
																</v-row>
															</v-col>
															<v-col cols="6" class="pl-0 py-0">
																<span class="text-body-2">
																	<span v-if="detailTDO.tdo_status_created_user_name">{{ detailTDO.tdo_status_created_user_name }}</span>
																	<span v-else>-</span>
																</span>
															</v-col>
															<v-col cols="6" class="pt-1 pb-0">
																<v-row class="pl-3 justify-space-between">
																	<v-col cols="11" class="pa-0"><div class="text-body-2">Tanggal Dibuat</div></v-col>
																	<v-col cols="1" class="pa-0"><div>:</div></v-col>
																</v-row>
															</v-col>
															<v-col cols="6" class="pl-0 pt-1 pb-0">
																<span class="text-body-2">{{ detailTDO.tdo_status_created_datetime | tanggal }}</span>
															</v-col>
														</v-row>
														<v-row>
															<v-col cols="6" class="pb-0">
																<v-row class="pl-3 justify-space-between">
																	<v-col cols="11" class="pa-0"><div class="text-body-2">Dikirim Oleh</div></v-col>
																	<v-col cols="1" class="pa-0"><div>:</div></v-col>
																</v-row>
															</v-col>
															<v-col cols="6" class="pl-0 pb-0">
																<span class="text-body-2">
																	<span v-if="detailTDO.tdo_status_on_delivery_user_name">{{ detailTDO.tdo_status_on_delivery_user_name }}</span>
																	<span v-else>-</span>
																</span>
															</v-col>
															<v-col cols="6" class="pt-1 pb-0">
																<v-row class="pl-3 justify-space-between">
																	<v-col cols="11" class="pa-0"><div class="text-body-2">Tanggal Dikirm</div></v-col>
																	<v-col cols="1" class="pa-0"><div>:</div></v-col>
																</v-row>
															</v-col>
															<v-col cols="6" class="pl-0 pt-1 pb-0">
																<span class="text-body-2">{{ detailTDO.tdo_status_on_delivery_datetime | tanggal }}</span>
															</v-col>
														</v-row>
													</div>
												</v-col>
												<v-col cols="6">
													<div>
														<v-row>
															<v-col cols="6" class="py-0">
																<v-row class="pl-3 justify-space-between">
																	<v-col cols="11" class="pa-0"><div class="text-body-2">Diterima Oleh</div></v-col>
																	<v-col cols="1" class="pa-0"><div>:</div></v-col>
																</v-row>
															</v-col>
															<v-col cols="6" class="pl-0 py-0">
																<span class="text-body-2">
																	<span v-if="detailTDO.tdo_status_delivered_user_name">{{ detailTDO.tdo_status_delivered_user_name }}</span>
																	<span v-else>-</span>
																</span>
															</v-col>
															<v-col cols="6" class="pt-1 pb-0">
																<v-row class="pl-3 justify-space-between">
																	<v-col cols="11" class="pa-0"><div class="text-body-2">Tanggal Diterima</div></v-col>
																	<v-col cols="1" class="pa-0"><div>:</div></v-col>
																</v-row>
															</v-col>
															<v-col cols="6" class="pl-0 pt-1 pb-0">
																<span class="text-body-2">{{ detailTDO.tdo_status_delivered_datetime | tanggal }}</span>
															</v-col>
														</v-row>
													</div>
												</v-col>
											</v-row>
										</div>
									</div>
									<div class="pb-3" v-if="detailWarehouse">
										<v-card outlined class="mt-3">
											<v-row class="py-3">
												<v-col cols="12" class="py-0">
													<div v-if="detailTDO.tdo_type == 'in' && detailTDO.warehouse_from">
														<div class="pl-4 text-body-2 font-weight-bold">Warehouse Pengirim</div>
														<div class="pl-4 pt-1">{{ detailTDO.warehouse_from.warehouse_name }}</div>
														<div class="pl-4 pt-1">{{ detailTDO.warehouse_from.warehouse_mobilephone }}</div>
														<div class="pl-4 pt-1 text-body-2">{{ addressText(detailTDO.warehouse_from) }}</div>
													</div>
													<div v-else-if="detailTDO.tdo_type == 'out' && detailTDO.warehouse_to">
														<div class="pl-4 text-body-2 font-weight-bold">Warehouse Tujuan</div>
														<div class="pl-4 pt-1">{{ detailTDO.warehouse_to.warehouse_name }}</div>
														<div class="pl-4 pt-1">{{ detailTDO.warehouse_to.warehouse_mobilephone }}</div>
														<div class="pl-4 pt-1 text-body-2">{{ addressText(detailTDO.warehouse_to) }}</div>
													</div>
												</v-col>
											</v-row>
										</v-card>
									</div>
									<div class="mt-3" v-if="productSummary">
										<v-card outlined>
											<v-simple-table class="white-row">
												<template v-slot:default>
													<thead class="deep-purple lighten-5">
														<tr>
															<th class="text-left">Nama Produk</th>
															<th class="text-center">Dikirim</th>
															<th class="text-center">Diterima</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="product in detailTDO.tdo_detail" :key="product.tdo_detail_id">
															<td class="text-left">{{ product.tdo_detail_product_name }}</td>
															<td class="text-center">{{ product.tdo_detail_quantity_sent | toNumber }}</td>
															<td class="text-center">{{ product.tdo_detail_quantity_received | toNumber }}</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>
									</div>
									<div class="mt-5" v-if="note">
										<div class="text-body-2 font-weight-bold">Catatan</div>
										<div class="pt-2 text-body-2">
											<div v-if="detailTDO.tdo_note">{{ detailTDO.tdo_note }}</div>
											<div v-else>Tidak ada catatan</div>
										</div>
									</div>
								</div>
							</v-card>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'
// import printJS from 'print-js'
import $ from 'jquery'

export default {
	data () {
		return {
			header: true,
			detailLetter: true,
			detailStatus: true,
			detailWarehouse: true,
			productSummary: true,
			note: true,
		}
	},
	computed: {
		...mapState('tdo', ['detailTDO']),
		...mapState('common', ['letterHeader']),

	},
	props: {
		dialog: Boolean
	},
	methods: {
		hideDialog() {
			this.$emit('hideDialog')
		},
		async printDiv(val) {
			var tempTitle = await document.title
			document.title = await val
			await $("#app").find(".v-main").css({ display: "none" });
			await window.print()
			await $("#app").find(".v-main").css({ display: "block" });
			setTimeout(() => { document.title = tempTitle }, 1000)
		},
		addressText(value) {
			var data = []
			if (value.warehouse_address)
				data.push(value.warehouse_address)
			if (value.warehouse_subdistrict_name)
				data.push(value.warehouse_subdistrict_name)
			if (value.warehouse_city_name)
				data.push(value.warehouse_city_name)
			if (value.warehouse_province_name)
				data.push(value.warehouse_province_name)
			return data.join(', ')
		}
	},
	watch: {
		dialog(val) {
			if (!val) {
				this.header = true
				this.detailLetter = true
				this.detailStatus = true
				this.detailWarehouse = true
				this.productSummary = true
				this.note = true
			}
		}
	},
};
</script>